(function() {
    angular
        .module('emarket.auth')
        .controller('AuthController', ['$state', '$scope', '$timeout', '$http', '$mdToast', '$auth', '$log', 'Auth', 'StateQueue', 'Utils', function($state,
            $scope,
            $timeout,
            $http,
            $mdToast,
            $auth,
            $log,
            Auth,
            StateQueue,
            Utils) {
            var vm = this;
            vm.loadingText = 'Autenticando Espere';
            vm.login = function(user) {
                vm.isLoading = true;
                vm.message = null;
                vm.invalidCredentials = false;
                if (!user.password) {
                    return Utils.focus('input[name="password"]');
                }
                Auth.login(user)
                    .then(function(response) {
                        vm.loadingText = 'Correcto... espere';
                        vm.isLoading = false;
                        var state = StateQueue.getNext();
                        var hasValidPhone = response.user.phones
                            ? response.user.phones.some(function(phone) {
                                return phone.status === 'validated';
                            })
                            : false;
                        if (state.name === 'main.post.create' && !hasValidPhone) {
                            $state.go('main.profile.edit.phone', { location: 'replace' });
                        } else {
                            StateQueue.go();
                            // $log.info(state);
                            // $state.go(state.name, state.params);
                        }
                    })
                    .catch(function(response) {
                        response = response.data;
                        vm.isLoading = false;
                        $timeout(function() {
                            vm.invalidCredentials = true;
                        }, 500);
                        if (response && response.message) {
                            vm.errorMessage = response.message;
                        }
                    });
            };
        }]);
}());
